import React, { useEffect, useState, useContext, Link } from "react";
import { loadStripe } from "@stripe/stripe-js";
import { Elements } from "@stripe/react-stripe-js";
import UserContext from "../context/UserContext";
import SpecialStripePay from "./SpecialStripePay";
import { api } from "../utils/apiHelper";
import "../styles/CheckOut.css";

const stripePromise = loadStripe("pk_live_nZvWGLv87Odj065JZPm631Ce");
//northsiders
const ProductPay = () => {
  const { authUser } = useContext(UserContext);

  const [product, setProduct] = useState(null);
  const [selectedPrice, setSelectedPrice] = useState(15);
  const [loading, setLoading] = useState(true);

  const [showGuestCard, setShowGuestCard] = useState(false);
  const [guestEmail, setGuestEmail] = useState("");
  const [showPaymentForm, setShowPaymentForm] = useState(false);

  const [purchaseSuccess, setPurchaseSuccess] = useState(false);
  const [purchaseMessage, setPurchaseMessage] = useState("");
  const [purchaseEmail, setPurchaseEmail] = useState("");
  
  const publishing = `publishing.png`;

  useEffect(() => {
    const fetchProduct = async () => {
      try {
        const response = await api("/special-products");

        const activeProduct = response.find((p) => p.active);

        setProduct(activeProduct || null);

console.log(
  "Frontend productId:",
  activeProduct?.productId
);
        if (activeProduct?.priceOptions?.length) {
          const defaultPrice =
            activeProduct.priceOptions.find((p) => p > 0) ??
            activeProduct.priceOptions[0];

          setSelectedPrice(defaultPrice);
        }
      } catch (err) {
        console.error(err);
      } finally {
        setLoading(false);
      }
    };

    fetchProduct();
  }, []);

  const getGuestUserId = () => {
  let guestId = localStorage.getItem("guestUserId");

  if (!guestId) {
    guestId = `guest-${crypto.randomUUID()}`;
    localStorage.setItem("guestUserId", guestId);
  }

  return guestId;
};

const handleGuestCheckout = (e) => {
  e.preventDefault();

  const cleanEmail = guestEmail.trim();

  if (!cleanEmail) {
    alert("Please enter an email.");
    return;
  }

  getGuestUserId();

  // Do not save guestEmail in localStorage.
  setGuestEmail(cleanEmail);
  setShowGuestCard(false);
  setShowPaymentForm(true);
};

const handleProceedToPayment = () => {
  const isLoggedIn = !!authUser?._id;

  if (!isLoggedIn) {
    getGuestUserId();

    // Always require a new email for guest checkout.
    setGuestEmail("");
    setShowGuestCard(true);
    setShowPaymentForm(false);
    return;
  }

  setShowGuestCard(false);
  setShowPaymentForm(true);
};

  const handlePaymentSuccess = (message) => {
  const emailUsed = authUser?.email || guestEmail.trim();

  setPurchaseSuccess(true);
  setPurchaseMessage(message || "");
  setPurchaseEmail(emailUsed);
  setShowPaymentForm(false);
  setGuestEmail("");
};

  if (loading) return <p>Loading...</p>;

  if (!product) {
    return <p>No active special offer.</p>;
  }

  const cartItems = [
    {
      projectId: product.productId,
      projectTitle: product.title,
      ownerId: "6a28880d2ae5c4b98b6c84e2", // support account id
      ownerUsername: "Edit Farmer",
      price: selectedPrice,
      productCat: "special",
      quantityAvailable: 1,
      addedAt: new Date().toISOString(),
      image: product.image,
      file: product.file,
    },
  ];

 return (
  <div className="check-container">
  {purchaseSuccess ? (
  <div className="success-message">
    <p>
      ✅ {purchaseMessage || "Thank you for your purchase!"}
    </p>

    <p>
      Your purchased file was sent to{" "}
      <strong>{purchaseEmail}</strong>.
    </p>

    <p>
      Please check your inbox and spam or junk folder.
    </p>
  </div>
) : (
  <div className="product-card">
    
  <img src={publishing}  className="publishing" />
  
   <h2>{product.title}</h2>
    <p>{product.description}</p>
    {product.image?.url && (
      <img
        src={product.image.url}
        alt={product.title}
        className="special-manager-image"
      />
    )}

    <div className="price-buttons">
      {product.priceOptions.map((price) => (
        <button
          key={price}
          className={selectedPrice === price ? "selected" : ""}
          onClick={() => setSelectedPrice(price)}
        >
          {price === 0 ? "Free" : `$${price}`}
        </button>
      ))}
    </div>

  {!authUser && (
  <>
    <h3>Checkout as Guest</h3>

    <input
      type="email"
      value={guestEmail}
      onChange={(e) => setGuestEmail(e.target.value)}
      placeholder="Email for your receipt and download"
      className="guest-email-input"
      required
    />
  </>
)}

    <Elements stripe={stripePromise}>
     <SpecialStripePay
  total={selectedPrice}
  product={product}
  authUser={authUser}
  guestEmail={guestEmail}
  onPaymentSuccess={handlePaymentSuccess}
/>
    </Elements>
  </div>
)}
  </div>
);
  };

export default ProductPay;